<ng-template #streamCreatorModal class="stream-creator-modal" let-c="close" let-d="dismiss">
    <a (click)="d('Cross click')" data-cy="close-modal" class="stream-creator-modal__close-btn" title="Close Stream Modal">
        <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
    </a>
    <h2 class="stream-creator-modal__title">
        {{stream ? 'Edit stream' : 'Create your stream'}}
    </h2>
    <stream-creator
        [showCloseModalButton]="true"
        [stream]="stream"
        (closeStreamModalEmitter)="closeStreamModal()"
        (updatedStreamEmitter)="saveStreamUpdate($event)"></stream-creator>
</ng-template>


